export const processVideoUrl = (url) => {
  if (!url) return null;
  
  // Handle Loom videos
  if (url.includes('loom.com')) {
    const loomId = url.split('/share/')[1]?.split('?')[0] || url.split('/')[4];
    if (loomId) {
      return `https://www.loom.com/embed/${loomId}?hideEmbedTopBar=true`;
    }
  }
  
  // Handle YouTube (standard and short links)
  if (url.includes('youtube.com/watch')) {
    const videoId = new URLSearchParams(new URL(url).search).get('v');
    return `https://www.youtube.com/embed/${videoId}`;
  }
  if (url.includes('youtu.be/')) {
    const videoId = url.split('youtu.be/')[1]?.split('?')[0];
    return `https://www.youtube.com/embed/${videoId}`;
  }

  // Handle Vimeo
  if (url.includes('vimeo.com')) {
    const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
    return `https://player.vimeo.com/video/${videoId}`;
  }

  return url;
};